var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "preview-class",
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      width: 500
    },
    on: {
      cancel: _vm.closePreview
    }
  }, [_vm.isShow === "video" && _vm.previewVisible ? _c("video", {
    attrs: {
      width: "100%",
      controls: "",
      type: "video",
      id: "video",
      autoplay: ""
    }
  }, [_c("source", {
    attrs: {
      src: "",
      type: "video/ogg"
    }
  }), _c("source", {
    attrs: {
      src: "",
      type: "video/webm"
    }
  }), _c("source", {
    attrs: {
      src: "",
      type: "video/mp4"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("您的浏览器不支持video标签哦，请联系管理员")) + " ")]) : _vm._e(), _vm.isShow === "image" && _vm.showSrc ? _c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: _vm.$t("加载错误"),
      src: _vm.showSrc
    }
  }) : _vm._e(), _vm.fileList.length > 1 ? _c("a-icon", {
    attrs: {
      type: "left"
    },
    on: {
      click: _vm.showLast
    }
  }) : _vm._e(), _vm.fileList.length > 1 ? _c("a-icon", {
    attrs: {
      type: "right"
    },
    on: {
      click: _vm.showNext
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };